import { useContext } from "react";
import { GridColumn as Column } from "@progress/kendo-react-grid/dist/npm/GridColumn";
import { EditProjectContext } from "../../../EditProjectContext";
import { ProjectState } from "../../../../ViewModel/ProjectState";
import { IsUnloadedInMultiDockCell } from "./IsUnloadedInMultiDockCell";
import { ColumnMenu } from "../../../../../Layout/Grid/Filter/ColumnMenu";
import { IsUnloadedInMultiDockColumnMenu } from "./IsUnloadedInMultiDockColumnMenu";

export function PlantDockGridColumns() {
  const { project } = useContext(EditProjectContext);
  const editable = project.State === ProjectState.Sandbox;
  return [
    <Column
      width="100px"
      key="PlantGsdb"
      field="PlantGsdb"
      title="Plant Gsdb"
      filter="text"
      editable={false}
      resizable
      columnMenu={ColumnMenu}
    />,
    <Column
      width="100px"
      key="DockCode"
      field="DockCode"
      title="Dock Code"
      filter="text"
      editable={false}
      resizable
      columnMenu={ColumnMenu}
    />,
    <Column
      width="250"
      key="IsUnloadedInMultiDock"
      field="IsUnloadedInMultiDock"
      title="Is Unloaded in Collect-Dock"
      cell={IsUnloadedInMultiDockCell}
      editable={editable}
      resizable
      columnMenu={IsUnloadedInMultiDockColumnMenu}
    />,
  ];
}
